
import React from 'react';

const ContactHero: React.FC = () => {
  return (
    <section 
      className="relative py-32 bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://readdy.ai/api/search-image?query=Professional%20business%20communication%20and%20contact%20center%2C%20modern%20office%20environment%20with%20customer%20service%20representatives%2C%20biotechnology%20company%20headquarters%20with%20glass%20building%20facade%20and%20professional%20atmosphere&width=1920&height=800&seq=contact-hero&orientation=landscape')`
      }}
    >
      <div className="max-w-7xl mx-auto px-6 text-center text-white">
        <h1 className="text-5xl font-bold mb-6">
          联系<strong>我们</strong>
        </h1>
        <p className="text-xl mb-8 max-w-3xl mx-auto leading-relaxed">
          定制化<strong>科研服务</strong>团队随时为您提供技术咨询和解决方案
        </p>
        <div className="flex flex-wrap justify-center gap-6 mt-12">
          <div className="bg-white/20 backdrop-blur-sm rounded-lg px-8 py-4">
            <i className="ri-time-line text-3xl mb-2 block"></i>
            <span className="text-lg font-semibold">24小时响应</span>
          </div>
          <div className="bg-white/20 backdrop-blur-sm rounded-lg px-8 py-4">
            <i className="ri-user-star-line text-3xl mb-2 block"></i>
            <span className="text-lg font-semibold">专家团队</span>
          </div>
          <div className="bg-white/20 backdrop-blur-sm rounded-lg px-8 py-4">
            <i className="ri-shield-check-line text-3xl mb-2 block"></i>
            <span className="text-lg font-semibold">专业服务</span>
          </div>
          <div className="bg-white/20 backdrop-blur-sm rounded-lg px-8 py-4">
            <i className="ri-global-line text-3xl mb-2 block"></i>
            <span className="text-lg font-semibold">全球支持</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;
